import React, { useState } from "react";
import "./SectionFour.css";

function SectionFour() {
  const [active, setActive] = useState(1);

  return (
    <div className="section-four">
      <div className="container-fluid">
        <div className="row mx-0 px-0">
          <div className="col-12 d-flex justify-content-center">
            <span className="section-four-h1">Frequently Asked Questions</span>
          </div>
        </div>
        <div className="row mx-0 px-0 d-flex justify-content-center">
          <div className="col-lg-6 d-flex justify-content-center">
            <div
              className="accordion section-four-accordion"
              id="accordionExample"
            >
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    onClick={() => setActive(1)}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    How does Deal Direct Homes work?
                    <img
                      src={`/img/${
                        active === 1 ? "faq-icon" : "faq-icon-2"
                      }.svg`}
                      className="img-fluid ms-auto mobile-acc-image"
                      alt=""
                    />
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    It's Simple, Deal Direct Homes and their Affiliates walk
                    you though the home buying process. Just enter an address, a
                    Zip Code or City and State in the search bar select a
                    property you want to view, Buy/Tour then proceed through the
                    prompts including Financing verification. You will then be
                    contacted by each of the Affiliates that will write your
                    offer and walk you through all the milestones of a Real
                    Estate Transaction. You save thousands of dollars by not
                    paying Realtor Commissions and have a smooth and seamless
                    buying experience!
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                    onClick={() => setActive(2)}
                  >
                    Can I search for listings for sale on this site?
                    <img
                      src={`/img/${
                        active === 2 ? "faq-icon" : "faq-icon-2"
                      }.svg`}
                      className="img-fluid ms-auto mobile-acc-image"
                      alt=""
                    />
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                  Yes, you may look at homes for sale by entering either a Zip Code, specific property address or City and State.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                    onClick={() => setActive(3)}
                  >
                    Do the Real Estate Agents work for Deal Direct Homes?
                    <img
                      src={`/img/${
                        active === 3 ? "faq-icon" : "faq-icon-2"
                      }.svg`}
                      className="img-fluid ms-auto mobile-acc-image"
                      alt=""
                    />
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    No. Each agent, whether a Listing or Showing agent, is
                    independent of Deal Direct Homes. However, they are still
                    regulated within their Licensing state.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                    onClick={() => setActive(4)}
                  >
                    How do I get in touch with an agent?
                    <img
                      src={`/img/${
                        active === 4 ? "faq-icon" : "faq-icon-2"
                      }.svg`}
                      className="img-fluid ms-auto mobile-acc-image"
                      alt=""
                    />
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Simple, just complete your profile and answer the financing
                    questions and you will be connected to an agent quickly.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                    onClick={() => setActive(5)}
                  >
                    Can I schedule an appointment to see a home through Deal
                    Direct Homes?
                    <img
                      src={`/img/${
                        active === 5 ? "faq-icon" : "faq-icon-2"
                      }.svg`}
                      className="img-fluid ms-auto mobile-acc-image"
                      alt=""
                    />
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Absolutely, once you have located your desired property
                    using the search bar and click on Take a Tour you will be
                    able to complete your profile and Schedule a tour.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                    onClick={() => setActive(6)}
                  >
                    Can I Advertise on Deal Direct Homes website or other media?
                    <img
          style={{zIndex: "20"}}
                      
                      src={`/img/${
                        active === 6 ? "faq-icon" : "faq-icon-2"
                      }.svg`}
                      className="img-fluid ms-auto mobile-acc-image"
                      alt=""
                    />
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    You Bet! We currently have over 15 Service Provider
                    Categories available for each zip code. We only accept a
                    single (1) Provider from each Zip Code. We are currently in
                    CA only. There are over 1000 Zip Codes with more than 10,000
                    Residences in CA alone. See Service Provider button at the
                    bottom of this site. Make sure to sign up for as many zip
                    codes as you like. Again, first come first served.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionFour;
